import 'jquery'
import bodymovin from 'lottie-web'

$('.lottie-animation').livequery(function() {
  bodymovin.loadAnimation({ loop: true, autoplay: true, container: this, renderer: 'svg', ...this.dataset })
})
